import { useMe } from '../api/queries.js';

/** Premium status of the signed-in user (from /api/auth/me). */
export function usePremium(): { active: boolean; until: string | null; loading: boolean } {
  const me = useMe();
  const premium = me.data?.user.premium;
  return { active: premium?.active ?? false, until: premium?.until ?? null, loading: me.isPending };
}
